import React from "react"
import PropTypes from "prop-types"

class ConnectAd extends React.Component {
  constructor(props) {
    super(props)
  }

  adText() {
    const rand = Math.floor(Math.random()*10)
    switch (rand) {
      case 0:
        return 'This ad pays Lexody employees.'
        break;
      case 1:
        return 'This ad allows us to offer most features for free.'
        break;
      case 2:
        return 'This ad keeps Lexody alive.'
        break;
      case 3:
        return 'This ad pays our rent.'
        break;
      case 4:
        return 'This ad supports Lexody.'
        break;
      case 5:
        return 'This ad pays our bills.'
        break;
      case 6:
        return 'This ad pays our developers.'
        break;
      case 7:
        return 'This ad subsidizes users who use Lexody for free.'
        break;
      default:
      return 'This ad pays our server costs.'
    }
  }

  render () {
      return (
        <div className="profile_teaser_container">
          <div>
            <h4 style={{textAlign: 'left'}}><span style={{color: 'rgba(1, 87, 155, .3)'}}>#AD</span> {this.adText()}</h4>
          </div>
            <ins className="adsbygoogle "
              style={{display:"block"}}
              data-ad-format="fluid"
              data-ad-layout-key="-fb+5w+4e-db+86"
              data-ad-client="ca-pub-2283458667333950"
              data-ad-slot="9485646196"></ins>
         </div>
      );
    }

}


export default ConnectAd;
